<template>
  <div class="header">
    <div class="warp clearfix">
      <div class="zncs_logo">
        <a href="/"><img src="@/assets/image/home/logo_03.png"></a>
      </div>
      <div class="specialty"><span>•</span>智能时代背景下<p style="padding-left:18px;">精数智 强实战 铸合规的税务会计师</p>
      </div>
    </div>
    <div class="Menu">
      <ul class="clearfix">
        <li><router-link :class="{ 'active': activeMenu === '/index' }"
            to="/index">首&nbsp;&nbsp;&nbsp;&nbsp;页</router-link>
        </li>
        <li><a target="_blank" href="http://www.ca-sme.org/category/Category/list/cid/53">协会介绍</a></li>
        <li><router-link :class="{ 'active': activeMenu === '/certificate' }" to="/certificate">项目介绍</router-link></li>
        <!-- <li><router-link to="" >项目介绍</router-link></li> -->

        <li><a target="_blank" href="http://www.ca-sme.org/category/Category/index/cid/367">协会动态</a></li>
        <li><a target="_blank" href="http://www.ca-sme.org/category/Category/index/cid/368">协会通告</a></li>
        <!-- <li><router-link :class="{'active':activeMenu==='/certificate'}"  to="/certificate">证书介绍</router-link></li> -->
        <li><router-link :class="{ 'active': activeMenu === '/authInst' }" to="/authInst">授权机构</router-link></li>
        <!-- <li><router-link :class="{'active':activeMenu==='/onLine'}"  to="/onLine">在线系统</router-link></li> -->
        <!-- <li><router-link :class="{ 'active': activeMenu === '/contact' }" to="/contact">联系我们</router-link></li> -->
        <!--        <li><a target="_blank" href="http://zncw.ca-sme.org/v/cwgl/login.html">报名入口</a></li>-->
        <!-- <li><a target="_blank" href="http://www.ca-sme.org/index/generalquery">证书查询</a></li> -->
        <!--        <li><a target="_blank" href="http://zncw.ca-sme.org/v/cwgl/login.html">报名入口</a></li>-->
        <li><a target="_blank" href="http://www.paac.net.cn/Cert/certqueryindex">证书管理</a></li>
        <li style="width: 110px;"><a target="_blank" href="/login">学员报考系统</a></li>
        <!-- <li><a target="_blank" href="/blogin">登录学习</a></li>
        <li><a target="_blank" href="/clogin">TAPA继续教育</a></li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import { Popup } from 'vant';
export default {
  data() {
    return {
      show: false
    }
  },
  components: {
    [Popup.name]: Popup,
  },
  computed: {
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    }

  },
  created() { },

  mounted() {
  },
  activated() { },
  methods: {}
}
</script>
<style lang="less">
.header {
  width: 100%;
  background: #fff;

  .warp {
    width: 1200px;
    padding: 26px 0px;
    margin: auto;
  }

  .zncs_logo {
    float: left;

    a {
      width: 686px;
      height: 91px;

      >img {
        width: 686px;
        height: 100px;
        display: block;
      }
    }
  }

  .specialty {
    float: right;
    margin-top: 32px;
    font-size: 18px;
    color: #285CAD;
    font-weight: bold;

    span {
      padding-right: 8px;
    }
  }

  .Menu {
    width: 100%;
    padding: 24px 0px;
    background: #b10403;

    ul {
      width: 1200px;
      margin: auto;
      display: flex;
      li {
          width: 118px;
        // width: 90px;
        float: left;
        text-align: center;
        flex: 1;
        a {
          display: block;
          font-size: 16px;
          color: #fff;
          background: url("../../../assets/image/line_bg.png") right center no-repeat;
          font-weight: bold;
        }

        a.active {
          color: #f2c266;
        }
      }

      li:last-child {
        a {
          background: none;
        }
      }
    }
  }
}



.zncw_title {
  height: 40px;
  line-height: 40px;

  em {
    width: 6px;
    height: 24px;
    margin: 8px 14px 0px 0px;
    float: left;
    background: #285CAD;
  }

  span {
    float: left;
    color: #333;
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
  }
}

.zncw_button {
  text-align: center;
  margin: 20px 0px 70px 0px;

  a {
    padding: 0px 40px;
    height: 70px;
    display: inline-block;
    line-height: 70px;
    background: #207DD3;
    font-size: 30px;
    color: #fff;
  }
}

.navigation_menu {
  .bg {
    width: 566px;
  }

  ul {
    padding-top: 82px;

    li {
      height: 46px;
      line-height: 46px;
      margin-bottom: 62px;

      img {
        width: 40px;
        float: left;
        margin: 0px 44px 0px 42px;
      }

      a {
        width: 100%;
        font-size: 32px;
        color: #323232;
        display: inline-block;
      }

      .active {
        color: #44B7C1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pubilc/header/index.vue